import { useLayoutEffect } from "react";
import { useRouter } from "./useRouter";

function setTheme(theme: string) {
  document.body.className = theme;
}
export default function useTheme() {
  const { topLevelRoute } = useRouter();
  useLayoutEffect(() => {
    switch (topLevelRoute) {
      case "admin": {
        setTheme("theme-admin");
        break;
      }
      case "firma": {
        setTheme("theme-firma");
        break;
      }
      case "kursus":
      case "linje": {
        setTheme("theme-kursus");
        break;
      }
      case "efteruddannelse": {
        setTheme("theme-efteruddannelse");
        break;
      }
      default: {
        setTheme("theme-person");
        break;
      }
    }

    return () => {};
  }, [topLevelRoute]);
}
